import { pad } from "../../qa";
import styles from "./SetIndex.module.css";

const MARK = { ok: "✓", warn: "▲", wip: "•" };
const LABEL = { ok: ", checked", warn: ", flagged", wip: ", in review" };

export default function SetIndex({ sets, current, marks, dimmed, reviewers, onSelect, onFirstFree }) {
  return (
    <section id="qa-sets" className={styles.section} aria-labelledby="qa-set-index">
      <header className={styles.head}>
        <h2 id="qa-set-index" className={styles.title}>Set Index</h2>
        <p className={styles.legend}>✓ Checked&nbsp;&nbsp;▲ Flagged&nbsp;&nbsp;• In review</p>
        <button type="button" className={styles.free} onClick={onFirstFree}>
          First free set →
        </button>
      </header>
      <div className={styles.grid}>
        {sets.map((set) => {
          const mark = marks[set.id];
          return (
            <button
              key={set.id}
              type="button"
              className={`${styles.block} ${current === set.id ? styles.current : ""} ${
                dimmed[set.id] ? styles.dim : ""
              }`}
              aria-current={current === set.id ? "true" : undefined}
              aria-label={`Set ${set.id}${mark ? LABEL[mark] : ""}`}
              onClick={() => onSelect(set.id)}
            >
              <span className={styles.num}>{pad(set.id)}</span>
              <span className={styles.who}>{reviewers[set.id] || "Open"}</span>
              {mark && (
                <span className={styles.mark} aria-hidden="true">
                  {MARK[mark]}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </section>
  );
}
